import { defineMessages } from 'react-intl';

export default defineMessages({
  notificationText: {
    id: 'detectAdBlock.notificationText',
    defaultMessage:
      'An Adblocker is detected. Part of the website might not work with Adblocker enabled. Please consider disabling it for this website.',
  },
});
